export default __webpack_public_path__ + "static/media/fotoEqualsSports.c30f4c90.png";